import { useApi } from './useApi'

// Variables disponibles para armar las plantillas de mensaje de WhatsApp de un
// grupo de invitados. Se resuelven contra los datos ya cargados en AdminPanel
// y en FormSalidas.
export const MENSAJE_VARIABLES = [
  { key: 'codigo', label: 'Código' },
  { key: 'encargado', label: 'Encargado' },
  { key: 'cantidad', label: 'Personas' },
  { key: 'autos', label: 'Autos' },
  { key: 'fechas', label: 'Fechas' },
  { key: 'zona', label: 'Zona' },
  { key: 'grupos', label: 'Grupos de predicación' },
  { key: 'territorios', label: 'Territorios asignados' },
  { key: 'link', label: 'Enlace de la salida de grupo' },
  { key: 'linkEstudios', label: 'Enlace para cargar estudios del grupo' },
  { key: 'linkPuntoTerritorio', label: 'Enlace al punto de encuentro en territorio' },
  { key: 'estudiante', label: 'Estudiante' },
  { key: 'telefonoEstudiante', label: 'Teléfono del estudiante' },
  { key: 'publicador', label: 'Publicador' },
  { key: 'telefonoPublicador', label: 'Teléfono del publicador' },
  { key: 'asignadoA', label: 'Asignado a' },
  { key: 'telefonoAsignadoA', label: 'Teléfono del asignado' },
  { key: 'direccionEstudio', label: 'Dirección del estudio' },
  { key: 'fechaInicioEstudio', label: 'Fecha de inicio del estudio' },
  { key: 'territorioEstudio', label: 'Territorio del estudio' },
]

export const DEFAULT_MENSAJE_PLANTILLA =
  'Hola {{encargado}}! Te confirmamos los datos del grupo {{codigo}}:\n' +
  'Fechas: {{fechas}}\n' +
  'Territorios asignados: {{territorios}}\n' +
  '¡Nos vemos en la predicación!'

export const nuevaPlantilla = (nombre = '', texto = DEFAULT_MENSAJE_PLANTILLA) => ({
  id: crypto.randomUUID(),
  nombre,
  texto,
})

export const renderMensajePlantilla = (template, vars) =>
  MENSAJE_VARIABLES.reduce(
    (text, { key }) => text.replaceAll(`{{${key}}}`, vars[key] ?? ''),
    template || ''
  )

export const useMensajePlantilla = () => {
  const api = useApi()

  const getPlantillas = async () => {
    const result = await api.get('/api/config')
    return result?.mensajePlantillas || []
  }

  const savePlantillas = (mensajePlantillas) => api.put('/api/config', { mensajePlantillas })

  return { getPlantillas, savePlantillas }
}
